var _excluded = ["children", "container"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import ReactDOM from 'react-dom';
import { useZIndexContext } from '../_hooks/ZIndex';
import { StyledPortal } from './Portal.styles';
/**
 * @deprecatedSince 11
 * @deprecated Intended for internal library development.
 * @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_coverage-portal--defaults)
 */
export function Portal(_ref) {
  var children = _ref.children,
    container = _ref.container,
    props = _objectWithoutProperties(_ref, _excluded);
  var zIndexCtx = useZIndexContext();
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(StyledPortal, _extends({}, props, {
    style: {
      zIndex: zIndexCtx.value
    }
  }), children), container || document.body);
}
//# sourceMappingURL=Portal.js.map